type FullNameArgs = {
  firstName?: string | null;
  lastName?: string | null;
};

export const getFullName = ({ firstName, lastName }: FullNameArgs) => [firstName, lastName].filter(Boolean).join(' ').trim();
